/* unplugin-vue-components disabled */import script from "./video-list.vue?vue&type=script&lang=jsx"
export * from "./video-list.vue?vue&type=script&lang=jsx"

import "./video-list.vue?vue&type=style&index=0&id=71e55575&lang=less&scoped=true"

import exportComponent from "/data/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71e55575"]])

export default __exports__